/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelLogisticsControl.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/logistics-control";

export class AutogenModelLogisticsControl<RowType extends ModelRow> extends Endpoint<RowType, RowLogisticsControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowLogisticsControl extends ModelRow<RowLogisticsControlFields> {
	constructor(values?: Partial<RowLogisticsControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowLogisticsControlFields {
	appt_confirmation: string;
	auto_mile_lookup: string;
	auto_rate: string;
	company_id: string;
	conf_fax_template: number;
	credit_warning_pct: number;
	del_template_id: number;
	dimension_surchg: string;
	edi_revenue_id: string;
	enable_manifesting: string;
	enforce_billto: string;
	enforce_contract: string;
	enforce_credit: string;
	enforce_revenu_cod: string;
	enforce_shipper_id: string;
	id: number;
	ins_warning_days: number;
	max_findnear_rows: number;
	max_rev_dist_rows: number;
	pickup_warning: number;
	profit_on_net: string;
	prompt_addl_orders: string;
	require_departure: string;
	service_fail_date: string;
	service_failures: string;
	set_bol_received: string;
	target_profit: number;
	verify_cargo_ins: string;
}

